// extracted by mini-css-extract-plugin
export default {"main":"DefaultCustomTitle_main__S-axg"};